import { Link } from "react-router-dom";
import { ReactComponent as Back } from "../img/icons/icon_blue_back.svg";
import { ReactComponent as LibIcon } from "../img/icons/icon_library.svg";

function NavigateBackWizardStep({ clickHandler, title, hideLibrary = false }) {
  return (
    <header className="border_bottom">
      <div className="inner_header">
        <Link
          to="#"
          onClick={() => clickHandler()}
          className="icon_left d-flex align-items-center"
        >
          <Back className="img-fluid" />
          <span className="head_title">{title}</span>
        </Link>
        {/* {!hideLibrary && (
          <Link to="/library" className="icon_right d-flex align-items-center">
            <LibIcon className="img-fluid" />
          </Link>
        )} */}
      </div>
    </header>
  );
}

export default NavigateBackWizardStep;
